import { render } from "./RpmSwitchInput.vue?vue&type=template&id=52845610"
import script from "./RpmSwitchInput.vue?vue&type=script&lang=js"
export * from "./RpmSwitchInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__